module.exports = __webpack_public_path__ + "static/media/ODDZ-BNB.839744b6.svg";